module.exports = __webpack_public_path__ + "static/media/CANARA.ad892f1a.svg";